'use strict';

goog.provide('Ntry.block');

Ntry.block = {};

Blockly.Blocks['maze_step_start'] = {
    init: function() {
        this.setColour('#3BBD70');
        this.appendDummyInput()
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/block_icon/start_icon_play.png',
                    '*',
                    'start'
                )
            )
            .appendField('시작하기를 클릭했을 때');
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_start = function(sprite, script) {
    return script.callReturn();
};

Blockly.Blocks['maze_step_jump'] = {
    init: function() {
        this.setColour('#FF6E4B');
        this.appendDummyInput()
            .appendField(Lang.Menus.jump_over)
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/jump.png', '*', 'endOrigin')
            );
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_jump = function(entity, script) {
    if (!script.isStart) {
        var unitComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.UNIT);
        var gridComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.GRID);

        script.isStart = true;
        script.isAction = true;

        var grid = { x: gridComp.x, y: gridComp.y };
        Ntry.addVectorByDirection(grid, unitComp.direction, 1);
        var fitEntities = Ntry.entityManager.find(
            {
                type: Ntry.STATIC.GRID,
                x: grid.x,
                y: grid.y,
            },
            {
                type: Ntry.STATIC.TILE,
                tileType: Ntry.STATIC.WALL,
            }
        );

        if (fitEntities.length) {
            Ntry.dispatchEvent('unitAction', Ntry.STATIC.WALL_CRASH);
            return script;
        }

        var callBack = function() {
            script.isAction = false;
        };
        Ntry.dispatchEvent('unitAction', Ntry.STATIC.JUMP, callBack);
        return script;
    } else if (script.isAction) {
        return script;
    } else {
        delete script.isAction;
        delete script.isStart;
        //Entry.engine.isContinue = false;
        return script.callReturn();
    }
};

Blockly.Blocks['maze_step_move_step'] = {
    init: function() {
        this.setColour('#A751E3');
        this.appendDummyInput()
            .appendField(Lang.Menus.maze_move_forward)
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/week/blocks/moveStep.png',
                    '*',
                    'endOrigin'
                )
            );
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_move_step = function(sprite, script) {
    if (!script.isStart) {
        script.isStart = true;
        script.isAction = true;
        var callBack = function() {
            script.isAction = false;
        };
        Ntry.dispatchEvent('unitAction', Ntry.STATIC.WALK, callBack);
        return script;
    } else if (script.isAction) {
        return script;
    } else {
        delete script.isAction;
        delete script.isStart;
        //Entry.engine.isContinue = false;
        return script.callReturn();
    }
};

Blockly.Blocks['maze_step_rotate'] = {
    init: function() {
        this.setColour('#A751E3');

        this.appendDummyInput().appendField(Lang.Menus.turn_en);
        this.appendDummyInput().appendField(
            new Blockly.FieldDropdown([
                [Lang.Menus.turn_left, 'LEFT'],
                [Lang.Menus.turn_right, 'RIGHT'],
            ]),
            'VALUE'
        );
        this.appendDummyInput()
            .appendField(Lang.Menus.turn_ko)
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/turnL.png', '*', 'endOrigin')
            );

        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_rotate = function(sprite, script) {
    if (!script.isStart) {
        script.isStart = true;
        script.isAction = true;
        var callBack = function() {
            script.isAction = false;
        };
        var direction = script.getField('VALUE');
        if (direction == 'LEFT') Ntry.dispatchEvent('unitAction', Ntry.STATIC.TURN_LEFT, callBack);
        else Ntry.dispatchEvent('unitAction', Ntry.STATIC.TURN_RIGHT, callBack);
        return script;
    } else if (script.isAction) {
        return script;
    } else {
        delete script.isAction;
        delete script.isStart;
        //Entry.engine.isContinue = false;
        return script.callReturn();
    }
};

Blockly.Blocks['maze_step_for'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField(Lang.Blocks.FLOW_repeat_basic_1);
        this.appendDummyInput().appendField(new Blockly.FieldTextInput(''), 'VALUE');
        this.appendDummyInput()
            .appendField(Lang.Blocks.FLOW_repeat_basic_2)
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/for.png', '*', 'endOrigin')
            );
        this.appendStatementInput('DO');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_for = function(sprite, script) {
    var iterNumber;
    if (!script.isLooped) {
        script.isLooped = true;
        var iterNumber = script.getField('VALUE', script);
        if (iterNumber < 0) throw new Error(Lang.Blocks.FLOW_repeat_basic_errorMsg);
        script.iterCount = Math.floor(iterNumber);
    }
    if (script.iterCount != 0 && !(script.iterCount < 0)) {
        script.iterCount--;
        return script.getStatement('DO', script);
    } else {
        delete script.isLooped;
        delete script.iterCount;
        return (returnBlock = script.callReturn());
    }
};

Blockly.Blocks['maze_step_for_true_1'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField(Lang.Menus.repeat_until_en);

        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/repeat_goal_1.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField(Lang.Menus.repeat_until_ko)
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/for.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setPreviousStatement(true);
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_for_true_1 = function(entity, script) {
    if (script.isRooped) {
        delete script.isRooped;
        return script;
    } else {
        script.isRooped = true;
    }

    return script.getStatement('STACK', script);
    /* stage 9 */
    var unitComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.UNIT);
    var gridComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.GRID);

    var fitEntities = Ntry.entityManager.find(
        {
            type: Ntry.STATIC.GRID,
            x: gridComp.x,
            y: gridComp.y,
        },
        {
            type: Ntry.STATIC.TILE,
            tileType: Ntry.STATIC.GOAL,
        }
    );

    if (fitEntities.length == 0) return script.getStatement('STACK', script);
    else return script.callReturn();
};

Blockly.Blocks['maze_step_if_1'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField(Lang.Menus.if_there_is_1);
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/if_target_1.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField(Lang.Menus.if_there_is_2)
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_if_1 = function(entity, script) {
    if (script.isLooped) {
        delete script.isLooped;
        return script.callReturn();
    }
    var unitComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.UNIT);
    var gridComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.GRID);

    var grid = { x: gridComp.x, y: gridComp.y };
    Ntry.addVectorByDirection(grid, unitComp.direction, 1);

    var existEntities = Ntry.entityManager.find({
        type: Ntry.STATIC.GRID,
        x: grid.x,
        y: grid.y,
    });
    if (existEntities.length == 0) return script.getStatement('STACK', script);

    var fitEntities = Ntry.entityManager.find(
        {
            type: Ntry.STATIC.GRID,
            x: grid.x,
            y: grid.y,
        },
        {
            type: Ntry.STATIC.TILE,
            tileType: Ntry.STATIC.WALL,
        }
    );

    if (!script.getStatement('STACK', script)) return null;
    if (fitEntities.length == 0) {
        return script.callReturn();
    } else {
        script.isLooped = true;
        return script.getStatement('STACK', script);
    }
};

Blockly.Blocks['maze_step_if_2'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField('만약 앞에');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/bitmap/maze2/obstacle_01.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField('있다면')
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_if_2 = function(entity, script) {
    if (script.isLooped) {
        delete script.isLooped;
        return script.callReturn();
    }
    var unitComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.UNIT);
    var gridComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.GRID);

    var grid = { x: gridComp.x, y: gridComp.y };
    Ntry.addVectorByDirection(grid, unitComp.direction, 1);

    var fitEntities = Ntry.entityManager.find(
        {
            type: Ntry.STATIC.GRID,
            x: grid.x,
            y: grid.y,
        },
        {
            type: Ntry.STATIC.TILE,
            tileType: Ntry.STATIC.OBSTACLE_BEE,
        }
    );

    if (!script.getStatement('STACK', script)) return null;
    if (fitEntities.length == 0) {
        return script.callReturn();
    } else {
        script.isLooped = true;
        return script.getStatement('STACK', script);
    }
};

Blockly.Blocks['maze_step_if_3'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField(Lang.Menus.if_there_is_1);
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/if_target_3.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField(Lang.Menus.if_there_is_2)
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_if_3 = function(entity, script) {
    if (script.isLooped) {
        delete script.isLooped;
        return script.callReturn();
    }
    var unitComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.UNIT);
    var gridComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.GRID);

    var grid = { x: gridComp.x, y: gridComp.y };
    Ntry.addVectorByDirection(grid, unitComp.direction, 1);

    var fitEntities = Ntry.entityManager.find(
        {
            type: Ntry.STATIC.GRID,
            x: grid.x,
            y: grid.y,
        },
        {
            type: Ntry.STATIC.TILE,
            tileType: Ntry.STATIC.OBSTACLE_BANANA,
        }
    );

    if (!script.getStatement('STACK', script)) return null;
    if (fitEntities.length == 0) {
        return script.callReturn();
    } else {
        script.isLooped = true;
        return script.getStatement('STACK', script);
    }
};

Blockly.Blocks['maze_repeat_until_1'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField('모든');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/repeat_until_goal_1.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField('를 만날 때 까지 반복')
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/for.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_repeat_until_1 = function(sprite, script) {
    return script.getStatement('STACK', script);
};

Blockly.Blocks['maze_repeat_until_2'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField('모든');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/repeat_goal_1.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField('를 만날 때 까지 반복')
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/for.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_repeat_until_2 = function(sprite, script) {
    return script.getStatement('STACK', script);
};

Blockly.Blocks['maze_define_function'] = {
    init: function() {
        this.setColour('#B57242');
        this.appendDummyInput()
            .appendField('약속하기')
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/week/blocks/function.png',
                    '*',
                    'endOrigin'
                )
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_define_function = function(entity, script) {
    if (!script.isStart) {
        script.isStart = true;
        return script.getStatement('STACK', script);
    } else {
        delete script.isStart;
        return script.callReturn();
    }
};

Blockly.Blocks['maze_call_function'] = {
    init: function() {
        this.setColour('#B57242');
        this.appendDummyInput()
            .appendField('약속 불러오기')
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/week/blocks/function.png',
                    '*',
                    'endOrigin'
                )
            );
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_call_function = function(entity, script) {
    if (!script.thread) {
        var scriptComp = Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.SCRIPT_CONTAINER);
        script.thread = new Ntry.Script(entity);
        script.thread.register = script.values;
        var funcScript = Blockly.Xml.textToDom(scriptComp.script);
        for (var i = 0; i < funcScript.childNodes.length; i++) {
            if (funcScript.childNodes[i].getAttribute('type') == 'maze_define_unfunction')
                script.thread.init(funcScript.childNodes[i]);
        }
        return script;
    } else {
        var thread = Ntry.computeThread(entity, script.thread);
        if (!thread) {
            delete script.thread;
            return script.callReturn();
        } else {
            script.thread = thread;
            return script;
        }
    }
};

Blockly.Blocks['number'] = {
    init: function() {
        this.setColour('#FFD974');
        this.appendDummyInput().appendField(new Blockly.FieldTextInput(''), 'NUM');
        this.setOutput(true, 'Number');
        this.setInputsInline(true);
        this.setTooltip(Blockly.Msg.MATH_NUMBER_TOOLTIP);
    },
};

Ntry.block.number = function(sprite, script) {
    return script.fields['NUM'];
};

Blockly.Blocks['True'] = {
    init: function() {
        this.setColour('#2FC9F0');
        this.appendDummyInput()
            .appendField(Lang.Blocks.JUDGEMENT_true, '#3D3D3D')
            .appendField(' ');
        this.setOutput(true, 'Boolean');
        this.setInputsInline(true);
        this.setTooltip('');
    },
};

Ntry.block.True = function(sprite, script) {
    return true;
};

Blockly.Blocks['True_un'] = {
    init: function() {
        this.setColour('#abcdf4');
        this.appendDummyInput()
            .appendField(Lang.Blocks.JUDGEMENT_true, '#3D3D3D')
            .appendField(' ');
        this.setOutput(true, 'Boolean');
        this.setInputsInline(true);
        this.setTooltip('');
    },
};

Ntry.block.True_un = Ntry.block.True;

////// un

Blockly.Blocks['maze_step_unstart'] = {
    init: function() {
        this.setColour('#37bd79');
        this.appendDummyInput()
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/start_un.png', '*', 'start')
            )
            .appendField(Lang.Menus.maze_when_run);
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_unstart = Ntry.block.maze_step_start;

Blockly.Blocks['maze_step_move_unstep'] = {
    init: function() {
        this.setColour('#cc9df9');
        this.appendDummyInput()
            .appendField(Lang.Menus.maze_move_forward)
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/week/blocks/move_right_un.png',
                    '*',
                    'endOrigin'
                )
            );
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_move_unstep = Ntry.block.maze_step_move_step;

Blockly.Blocks['maze_step_unjump'] = {
    init: function() {
        this.setColour('#fcab9d');
        this.appendDummyInput()
            .appendField(Lang.Menus.jump_over)
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/week/blocks/jump_un.png',
                    '*',
                    'endOrigin'
                )
            );
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_unjump = Ntry.block.maze_step_jump;

Blockly.Blocks['maze_step_unrotate'] = {
    init: function() {
        this.setColour('#cc9df9');
        this.appendDummyInput().appendField(
            new Blockly.FieldDropdown([
                ['왼쪽', 'LEFT'],
                ['오른쪽', 'RIGHT'],
            ]),
            'VALUE'
        );
        this.appendDummyInput()
            .appendField('으로 회전')
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/week/blocks/left_un.png',
                    '*',
                    'endOrigin'
                )
            );
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_unrotate = Ntry.block.maze_step_rotate;

Blockly.Blocks['maze_step_unfor'] = {
    init: function() {
        this.setColour('#abcdf4');
        this.appendDummyInput().appendField(Lang.Blocks.FLOW_repeat_basic_1);
        this.appendDummyInput().appendField(new Blockly.FieldTextInput(''), 'VALUE');
        this.appendDummyInput()
            .appendField(Lang.Blocks.FLOW_repeat_basic_2)
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/week/blocks/repeat_un.png',
                    '*',
                    'endOrigin'
                )
            );
        this.appendStatementInput('DO');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_unfor = Ntry.block.maze_step_for;

Blockly.Blocks['maze_step_unfor_true_2'] = {
    init: function() {
        this.setColour('#E5E5E5');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/repeat_goal_2.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField('만날 때 까지 반복', '#000000')
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/un_for.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setPreviousStatement(true);
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_unfor_true_2 = function(sprite, script) {};

Blockly.Blocks['maze_step_unif_1'] = {
    init: function() {
        this.setColour('#abcdf4');
        this.appendDummyInput().appendField(Lang.Menus.if_there_is_1);
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/if_target_1.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField(Lang.Menus.if_there_is_2)
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if_un.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_unif_1 = Ntry.block.maze_step_if_1;

Blockly.Blocks['maze_step_unif_2'] = {
    init: function() {
        this.setColour('#E5E5E5');
        this.appendDummyInput().appendField('만약 앞에', '#000000');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/if_target_2.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField('있다면', '#000000')
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/un_if.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_unif_2 = Ntry.block.maze_step_if_2;

Blockly.Blocks['maze_step_if_4'] = {
    init: function() {
        this.setColour('#498DEB');
        this.appendDummyInput().appendField('만약 앞에', '#FFFFFF');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/if_target_2.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField('있다면', '#FFFFFF')
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/if.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_if_4 = Ntry.block.maze_step_if_1;

Blockly.Blocks['maze_step_unif_3'] = {
    init: function() {
        this.setColour('#E5E5E5');
        this.appendDummyInput().appendField('만약 앞에', '#000000');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/if_target_3.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField('있다면', '#000000')
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/un_if.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_unif_3 = Ntry.block.maze_step_if_3;

Blockly.Blocks['maze_repeat_ununtil_1'] = {
    init: function() {
        this.setColour('#E5E5E5');
        this.appendDummyInput().appendField('모든', '#000000');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/repeat_until_goal_1.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField('를 만날 때 까지 반복', '#000000')
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/un_for.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_repeat_ununtil_1 = Ntry.block.maze_repeat_until_1;

Blockly.Blocks['maze_repeat_ununtil_2'] = {
    init: function() {
        this.setColour('#E5E5E5');
        this.appendDummyInput().appendField('모든', '#000000');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/repeat_until_goal_1.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField('를 만날 때 까지 반복(2)', '#000000')
            .appendField(
                new Blockly.FieldIcon('/legacy_img/assets/week/blocks/un_for.png', '*', 'endOrigin')
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_repeat_ununtil_2 = Ntry.block.maze_repeat_until_2;

Blockly.Blocks['maze_define_unfunction'] = {
    init: function() {
        this.setColour('#efc2a3');
        this.appendDummyInput()
            .appendField('약속하기')
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/week/blocks/function_un.png',
                    '*',
                    'endOrigin'
                )
            );
        this.appendStatementInput('STACK');
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_define_unfunction = Ntry.block.maze_define_function;

Blockly.Blocks['maze_call_unfunction'] = {
    init: function() {
        this.setColour('#efc2a3');
        this.appendDummyInput()
            .appendField('약속 불러오기')
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/week/blocks/function_un.png',
                    '*',
                    'endOrigin'
                )
            );
        this.setInputsInline(true);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_call_unfunction = Ntry.block.maze_call_function;

Blockly.Blocks['maze_step_unfor_true_1'] = {
    init: function() {
        this.setColour('#abcdf4');
        this.appendDummyInput().appendField(
            new Blockly.FieldImage(
                '/legacy_img/assets/ntry/block_inner/repeat_goal_1.png',
                22,
                22,
                'conical'
            )
        );
        this.appendDummyInput()
            .appendField(Lang.Menus.repeat_until, '#000000')
            .appendField(
                new Blockly.FieldIcon(
                    '/legacy_img/assets/week/blocks/repeat_un.png',
                    '*',
                    'endOrigin'
                )
            );
        this.appendStatementInput('STACK');
        this.setPreviousStatement(true);
        this.setInputsInline(true);
        this.setNextStatement(true);
        this.setTooltip('');
    },
};

Ntry.block.maze_step_unfor_true_1 = Ntry.block.maze_step_for_true_1;

Blockly.Blocks['number_un'] = {
    init: function() {
        this.setColour('#ffedc5');
        this.appendDummyInput().appendField(new Blockly.FieldTextInput(''), 'NUM');
        this.setOutput(true, 'Number');
        this.setInputsInline(true);
        this.setTooltip(Blockly.Msg.MATH_NUMBER_TOOLTIP);
    },
};

Ntry.block.number_un = Ntry.block.number;
